import { useRef } from "react";
import ReactQuill from "react-quill";

import "react-quill/dist/quill.snow.css";
import { FormField } from "../FormField";
import { ReachTextEditorProps } from "./ReachTextEditor.types";

import styles from "./ReachTextEditor.module.scss";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ align: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"]
  ]
};

const ReachTextEditor = ({
  defaultValue,
  onChange,
  ...formFieldProps
}: ReachTextEditorProps) => {
  const quillRef = useRef<ReactQuill>(null);

  return (
    <FormField containerClassName={styles.container} {...formFieldProps}>
      <ReactQuill
        ref={quillRef}
        defaultValue={defaultValue ?? ""}
        onChange={onChange}
        modules={modules}
        className={styles.quill}
      />
    </FormField>
  );
};

export default ReachTextEditor;
